/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


 
/** Unique tabs using H6 as an anchor **/
$($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
  	
  	var tabName = $(this).text();
  	tabContent = '';
  	
  	//check if h6 has text inside
 	if ($(this).text() != '') {
      	
      	//hide h6
    	$(this).hide();
  
      	//combine content between H6 elements
        $(this).nextUntil('h6').each(function() {
            tabContent = tabContent + this.outerHTML;
          	
          	//hide content
            $(this).hide();
        });
		
      	//generate tab HTML
      	$('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
        $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');

    } else {	

      	//hide empty H6
      	$(this).hide();
    }
});


setInterval(function(){
  jQuery(".ajaxcart__inner").find(".ajaxcart__product-meta").each(function(){
    var crntTxt = jQuery(this).text();
    //console.log(crntTxt);
    if(crntTxt.includes("_bold")){
      jQuery(this).hide();
    }
    if(crntTxt.includes("[object")){
      jQuery(this).hide();
    }
    
     
    if(crntTxt.includes("https://cdn.shopify.com")){
      jQuery(this).addClass("p_uploades");
    }
  });
  
   
  $(".ajaxcart__checkout").removeAttr("disabled");
 
}, 1);

// Fix selector padding after translation
document.addEventListener('DOMContentLoaded', () => {
    const selectorLabels = document.querySelectorAll('.selector-wrapper label');
    
    if (!selectorLabels.length || typeof theme.selectWrapper !== 'function') return;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                theme.selectWrapper();
            }
        });
    });

    selectorLabels.forEach(label => observer.observe(label, { childList: true, subtree: true, characterData: true }));
});

window.addEventListener('customily-options-loaded', function (e) {
   $('#cl_optionsapp .customily_option.Backbuckle .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.Backbuckle .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
  $('#cl_optionsapp .customily_option.ropechain .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.ropechain .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
  $('#cl_optionsapp .customily_option.chainstyle .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.chainstyle .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
    $('.customily_option.Backbuckle input.needsclick.needsfocus, .customily_option.textcolor input.needsclick.needsfocus').each(function(){
      var label_txt = $(this).val();
      $(this).next('label').after('<span class="label-txt">' + label_txt + '</span>');
  });
});

$('body').on('click', '.customily_option.Backbuckle .swatch.customily-swatch', function () {
    setTimeout(function () {
      $('.customily_option.Backbuckle input.needsclick.needsfocus, .customily_option.textcolor input.needsclick.needsfocus').each(function(){
         $(this).next('label').next('span.label-txt').remove();
          var label_txt = $(this).val();
          $(this).next('label').after('<span class="label-txt">' + label_txt + '</span>');
      });
      $('#cl_optionsapp .customily_option.Backbuckle .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.Backbuckle .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
    }, 50);
});
$('body').on('click', '.customily_option.chainstyle .swatch.customily-swatch', function () {
    setTimeout(function () {
      $('#cl_optionsapp .customily_option.ropechain .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
  $('#cl_optionsapp .customily_option.ropechain .swatch-container label').each(function (){
        $(this).css({  'width': '', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });   
    });
    }, 50);
});